import ProfileSubnav from './ProfileSubnav.component';

export default ProfileSubnav;
